export function estChampHerite(typeObjet, champ) {
	return champ.type !== 'ChampPopulation' && champ.idTypeObjet !== typeObjet.id;
}

export function estChampSurcharge(champ) {
	return champ.idChampSurcharge != null;
}

export function getTypeOccurrenceLien(typeLien) {
    switch(typeLien) {
        case 'CONTIENT':
            return 'PLUSIEURS';
        case 'APPARTIENT_A':
        case 'ASSOCIE_A':
            return 'UNE';
    }
}

export function getTypeOccurrenceLienReciproque(typeLien) {
    switch(typeLien) {
        case 'APPARTIENT_A':
            return 'PLUSIEURS';
        case 'CONTIENT':
        case 'ASSOCIE_A':
            return 'UNE';
    }
}

export function getTypeLien(typeOccurrence, typeOccurrenceReciproque) {
    if (!typeOccurrence || !typeOccurrenceReciproque) {
        return null;
    }
    if (typeOccurrence === 'UNE') {
        if (typeOccurrenceReciproque === 'UNE') {
            return 'ASSOCIE_A';
        } else {
            return 'APPARTIENT_A';
        }
    } else {
        if (typeOccurrenceReciproque === 'UNE') {
            return 'CONTIENT';
        } else {
            return 'ASSOCIE_A';
        }
    }
}

export function getClasseValeur(valeur) {
    if (!valeur) {
        return null;
    }
	if (valeur.forcee) {
		return 'valeur-forcee';
	}
    if (valeur.erreur) {
		switch(valeur.erreur.type) {
			case 'VALEUR_MANQUANTE':
                return 'valeur-manquante';
			case 'ENTREE_EN_ERREUR':
                return 'valeur-entree-en-erreur';
			case 'EXPRESSION_VIDE':
				return null;
			default:
                return 'valeur-en-erreur';
		}
	}
    switch(valeur.typeModif) {
        case 'A_RECALCULER':
            return 'valeur-a-recalculer';
        case 'SAISIE_PRISE_EN_COMPTE':
            return 'valeur-saisie-prise-en-compte';
        case 'SAISIE_A_PRENDRE_EN_COMPTE':
            return 'valeur-saisie-a-prendre-en-compte';
        case 'RECALCUL_IDENTIQUE':
            return 'valeur-recalcul-identique';
        case 'RECALCUL_DIFFERENT':
            return 'valeur-recalcul-different';
    }
    return null;
}
export function getBlocEntetesTableau(element, tableau) {
	switch(element.type) {
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
		case 'EnteteAgregatTotal':
		case 'EnteteAgregatGroupe':
		case 'FiltreTableau':
			return tableau.blocsEntetesObjets[element.position[0]];
		case 'EnteteExpression':
		case 'ValeurExpression':
		case 'ValeurAgregatTotal':
		case 'ValeurAgregatGroupe':
			return tableau.blocsEntetesObjets[element.position[0]].blocsEntetesExpressions[element.position[1]];
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
			if (element.position.length === 2) {
				return tableau.blocsEntetesObjets[element.position[0]];
			} else if (element.position.length === 3) {
				return tableau.blocsEntetesObjets[element.position[0]].blocsEntetesExpressions[element.position[1]];
			}
		}
	return null;
}

export function getBlocEntetesObjetsTableau(element, tableau) {
	return tableau.blocsEntetesObjets[element.position[0]];
}

export function getEnteteRegroupementTableau(element, tableau) {
	switch(element.type) {
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
		case 'EnteteAgregatGroupe':
			return getEnteteTableau(element, tableau);
		case 'ValeurAgregatGroupe':
			return getBlocEntetesObjetsTableau(element, tableau).entetesRegroupements[element.positionRegroupement];
		case 'EnteteAgregatTotal':
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
		case 'ValeurExpression':
		case 'ValeurAgregatTotal':
		case 'EnteteExpression':
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
			return null;
	}
	return null;
}

export function getEnteteTableau(element, tableau) {
	switch(element.type) {
		case 'EnteteObjetsBloc':
			return getBlocEntetesTableau(element, tableau).enteteObjetsBloc;
		case 'EnteteObjet':
			return getBlocEntetesTableau(element, tableau).enteteObjetsBloc.enteteObjetsChampCle;
		case 'EnteteExpression':
			return getBlocEntetesTableau(element, tableau).entetesExpressions[element.position[2]];
		case 'ValeurExpression':
			return getBlocEntetesTableau(element, tableau).entetesExpressions[element.position[2]].expression;
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
			if (element.position.length === 2) {
				return getBlocEntetesTableau(element, tableau).entetesVariables[element.position[1]];
			} else if (element.position.length === 3) {
				return getBlocEntetesTableau(element, tableau).entetesVariables[element.position[2]];
			}				
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
			return getBlocEntetesTableau(element, tableau).entetesRegroupements[element.position[1]];
		case 'EnteteAgregatTotal':
			return getBlocEntetesTableau(element, tableau).enteteObjetsBloc;
		case 'ValeurAgregatTotal':
		case 'ValeurAgregatGroupe':
				return getBlocEntetesTableau(element, tableau).entetesExpressions[element.position[2]].expressionAgregation;
		case 'EnteteAgregatGroupe':
			return getBlocEntetesTableau(element, tableau).entetesRegroupements[element.position[1]];
	}
	return null;
}

export function getConteneurMiseEnForme(element) {
	switch(element.type) {
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
		case 'EnteteExpression':
		case 'ValeurExpression':
		case 'EnteteVariable':
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
		case 'EnteteAgregatTotal':
		case 'EnteteAgregatGroupe':
			return getEnteteTableau(element, element.elementParent);
		case 'EnteteValeurVariable':
			return getEnteteTableau(element, element.elementParent).enteteValeurs;
		case 'ValeurAgregatTotal':
			return getBlocEntetesObjetsTableau(element, element.elementParent).enteteObjetsBloc;
		case 'ValeurAgregatGroupe':
			return getEnteteRegroupementTableau(element, element.elementParent);
		case 'SECTION':
		case 'ZONE':
		case 'TEXTE':
		case 'TABLEAU':
		case 'SELECTEUR':
		case 'GRAPHIQUE':
			return element;
	}
	return null;
}

export function getMiseEnFormeElement(element) {
	switch(element.type) {
		case 'EnteteObjetsBloc':
		case 'EnteteRegroupement':
			return getConteneurMiseEnForme(element).miseEnFormeEntete;
		case 'EnteteObjet':
		case 'EnteteExpression':
		case 'ValeurExpression':
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
			return getConteneurMiseEnForme(element).miseEnForme;
		case 'EnteteValeurGroupe':
			return getConteneurMiseEnForme(element).miseEnFormeValeurs;
		case 'EnteteAgregatTotal':
		case 'ValeurAgregatTotal':
			return getConteneurMiseEnForme(element).miseEnFormeAgregat;
		case 'EnteteAgregatGroupe':
		case 'ValeurAgregatGroupe':
			return getConteneurMiseEnForme(element).miseEnFormeAgregats;
		case 'SECTION':
		case 'ZONE':
		case 'TEXTE':
		case 'TABLEAU':
		case 'SELECTEUR':
		case 'GRAPHIQUE':
			return element.style;
	}
	return null;
}

export function getPositionBriqueRapport(element, elementParent) {
	switch(element.type) {
		case 'SECTION':
		case 'ZONE':
		case 'TABLEAU':
		case 'GRAPHIQUE':
		case 'TEXTE':
		case 'SELECTEUR':
			return {type: element.type, positionSection: element.positionSection, positionDansSection: element.positionDansSection, positionDansElement: []};
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
		case 'EnteteExpression':
		case 'ValeurExpression':
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
		case 'EnteteAgregatGroupe':
		case 'ValeurAgregatGroupe':
		case 'EnteteAgregatTotal':
		case 'ValeurAgregatTotal':
		case 'FiltreTableau':
			return {type: element.type, positionSection: elementParent.positionSection, positionDansSection: elementParent.positionDansSection, positionDansElement: element.position};
		case 'AxePrincipal':
		case 'ValeurAxe':
			return {type: element.type, positionSection: elementParent.positionSection, positionDansSection: elementParent.positionDansSection, positionDansElement: [0]};
		case 'SerieGraphique':
		case 'ValeurSerie':
			return {type: element.type, positionSection: elementParent.positionSection, positionDansSection: elementParent.positionDansSection, positionDansElement: [element.indiceSerie]};
	}
	return null;
}

export function getPositionSection(element, elementParent) {
	if (element.positionSection) {
		return element.positionSection;
	} else {
		return elementParent.positionSection;
	}
}

export function getPositionElement(element, elementParent) {
	switch(element.type) {
		case 'SECTION':
		case 'ZONE':
		case 'TABLEAU':
		case 'GRAPHIQUE':
		case 'TEXTE':
		case 'SELECTEUR':
			return element.positionDansSection;
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
		case 'EnteteExpression':
		case 'ValeurExpression':
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
		case 'EnteteAgregatGroupe':
		case 'ValeurAgregatGroupe':
		case 'EnteteAgregatTotal':
		case 'FiltreTableau':
			return elementParent.positionDansSection.concat([element.ligne, element.colonne]);
		case 'AxePrincipal':
			return elementParent.positionDansSection.concat([0, 0]);
		case 'ValeurAxe':
			const indiceValeur = elementParent.axePrincipal.valeurs.indexOf(element);
			return elementParent.positionDansSection.concat([0, 1 + indiceValeur]);
		case 'SerieGraphique': {
			const indiceSerie = elementParent.series.indexOf(element);
			return elementParent.positionDansSection.concat([1 + indiceSerie, 0]);
		}
		case 'ValeurSerie': {
			const indiceSerie = element.indiceSerie;
			const indiceValeur = elementParent.series[indiceSerie].valeurs.indexOf(element);
			return elementParent.positionDansSection.concat([1 + indiceSerie, 1 + indiceValeur]);
		}
	}
}

export function getElementsTableauLies(element, tableau) {
	return tableau.cellules.filter(
		c => c.type === element.type
			&& JSON.stringify(c.position) === JSON.stringify(element.position));
}

export function trouverPremiereCelluleTableau(tableau, type, indices) {
	return trouverPremiereCelluleTableauVerifiant(tableau, c => {
		return c.type === type 
			&& JSON.stringify(c.position) === JSON.stringify(indices)
	});
}

export function trouverPremiereCelluleTableauVerifiant(tableau, fonction) {
    const cellules = tableau.cellules.filter(c => fonction(c)).sort((c1, c2) => {
        return c1.colonne - c2.colonne + c1.ligne - c2.ligne;
    });
    if (cellules.length > 0) {
        return cellules[0];
    } else {
        return null;
    }
}

export function getMenuOuvertAjout(element, sensAjout) {
	switch(element.type) {
		case 'ZONE':
			const idMenu = (element.elements.length > 0 ? `ajout_${sensAjout}` : 'ajout_a_zone');
			return [idMenu];
		case 'TABLEAU':
		case 'GRAPHIQUE':
		case 'TEXTE':
		case 'SELECTEUR':
			return [`ajout_${sensAjout}`];
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
			return ['ajout_objet_depuis_tableau'];
		case 'EnteteExpression':
		case 'ValeurExpression':
		case 'ValeurAgregatGroupe':
		case 'ValeurAgregatTotal':
			return [`ajout_${sensAjout}_entete_expr`];
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
		case 'EnteteAgregatGroupe':
		case 'EnteteAgregatTotal':
			return [];
		case 'AxePrincipal':
		case 'ValeurAxe':
		case 'SerieGraphique':
		case 'ValeurSerie':
			return [`ajout_${sensAjout}_serie`];
	}
}

export function getCalculable(element, elementParent) {
	switch(element.type) {
		case 'TABLEAU': {
			let premierEnteteObjetsBloc = element.blocsEntetesObjets[0].enteteObjetsBloc;
			return {positionBrique: getPositionBriqueRapport(premierEnteteObjetsBloc, element), expression: premierEnteteObjetsBloc.expression};
		}
		case 'EnteteObjetsBloc':
		case 'EnteteObjet':
		case 'ValeurExpression':
		case 'EnteteVariable':
		case 'EnteteValeurVariable':
		case 'EnteteRegroupement':
		case 'EnteteValeurGroupe':
		case 'ValeurAgregatTotal':
		case 'ValeurAgregatGroupe':
			const enteteTableau = getEnteteTableau(element, elementParent);
			const positionBrique = getPositionBriqueRapport(element, elementParent);
			positionBrique.type = enteteTableau.type;
			return {positionBrique: positionBrique, expression: enteteTableau.expression, nomVariable: enteteTableau.nomVariable};
		case 'FiltreTableau':
			const filtre = elementParent.blocsEntetesObjets[element.position[0]].filtre;
			const positionFiltre = getPositionBriqueRapport(element, elementParent);
			return {positionBrique: positionFiltre, expression: filtre.expression};
		case 'SELECTEUR':
		case 'AxePrincipal':
		case 'SerieGraphique':
			return {positionBrique: getPositionBriqueRapport(element, elementParent), expression: element.expression, nomVariable: element.nomVariable};
		case 'ValeurAxe':
			let axePrincipal = elementParent.axePrincipal;
			return {positionBrique: getPositionBriqueRapport(axePrincipal, elementParent), expression: axePrincipal.expression, nomVariable: axePrincipal.nomVariable};
		case 'ValeurSerie':
			let serie = elementParent.series[element.indiceSerie];
			return {positionBrique: getPositionBriqueRapport(serie, elementParent), expression: serie.expression};
		default:
			return null;
	}
}

export function getLibelleExpression(calculable) {
	switch(calculable?.positionBrique?.type) {
		case 'EnteteObjetsBloc':
		case 'TABLEAU':
				return 'Objet(s)';		
		case 'ExpressionBloc':
		case 'EnteteObjetsChampCle':
			return 'Expression';
		case 'ExpressionBlocAgreg':
			return 'Expression d\'agrégation';
		case 'EnteteVariable':
			return 'Valeurs de la variable';
		case 'EnteteRegroupement':
			return 'Regroupement';
		case 'FiltreTableau':
			return 'Filtre';
		case 'SELECTEUR':
			return 'Liste de valeurs';
		case 'AxePrincipal':
			return 'Valeurs de l\'axe';
		case 'SerieGraphique':
			return 'Valeurs de la série';
		case 'ExpressionDansTexte':
			return 'Expression';
		default:
			return null;			
		}
}

export function ecriretailleFichier(tailleFichier) {
    if (!tailleFichier) {
		return '?';
	}
    var indice = 0;
    const unites = ['Mo', 'Ko'];
    var tailleDansUnite = tailleFichier / Math.pow(1024, 2);
    while (tailleDansUnite < 1. && indice < unites.length - 1) {
        indice++;
        tailleDansUnite *= 1024.;
    }
    return `${Math.round(tailleDansUnite * 100) / 100} ${unites[indice]}`;
}

export const TypeNommage = Object.freeze({
	VARIABLE: {
		description: 'Le nom doit commencer par une minuscule, il ne peut contenir que des caractères non accentués, des chiffres et des underscores (_), et il ne peut dépasser 30 caractères',
		normerNom: (nom) => nom.charAt(0).toLowerCase() + nom.slice(1)
	},
	CLASSE: {
		description: 'Le nom doit commencer par une majuscule, il ne peut contenir que des caractères non accentués, des chiffres et des underscores (_), et il ne peut dépasser 30 caractères',
		normerNom: (nom) => nom.charAt(0).toUpperCase() + nom.slice(1)
	},
	CONSTANTE: {
		description: 'Le nom ne doit contenir que des lettres majuscules, des chiffres et des underscores (_), et il ne peut dépasser 30 caractères',
		normerNom: (nom) => nom.toUpperCase()
	}
});

export function normerNom(texte, typeNommage) {
	if (texte) {
		const nomNorme = texte.normalize("NFD").replace(/\p{Diacritic}/gu, "").replaceAll(/[^\w]/g, '_').substring(0, 30);
		return typeNommage.normerNom(nomNorme);
	}
}

export function getDescElement(element) {
	if (!element) {
		return null;
	}
	switch(element.type) {
		case 'SECTION':
			return {icone: 'fa fa-list-ol', libelle: 'Section'};
		case 'ZONE':
			return {icone: 'fa fa-square', libelle: 'Zone'};
		case 'TABLEAU':
			return {icone: 'fa fa-table', libelle: 'Tableau'};
		case 'TEXTE':
			if (element.positionDansSection[0] === -1) {
				return {icone: 'fa fa-hashtag', libelle: 'Titre'};
			} else {
				return {icone: 'fa fa-font', libelle: 'Texte'};
			}
		case 'GRAPHIQUE':
			return {icone: 'fa fa-chart-line', libelle: 'Graphique'};
		case 'SELECTEUR':
			return {icone: 'fa fa-crosshairs', libelle: 'Graphique'};
		case 'EnteteObjetsBloc':
			return {icone: 'fa fa-list', libelle: 'Entête d\'objet(s)'};
		case 'EnteteObjet':
			return {icone: 'fa fa-object-group', libelle: 'Objet'};
		case 'EnteteExpression':
			return {icone: 'fa fa-tag', libelle: 'Entête d\'expression'};
		case 'ValeurExpression':
			return {icone: 'fa fa-calculator', libelle: 'Valeur d\'expression'};
		case 'EnteteVariable':
			return {icone: 'fa fa-tag', libelle: 'Entête de variable'};
		case 'EnteteValeurVariable':
			return {icone: 'fa fa-ruler-horizontal', libelle: 'Valeur de variable'};
		case 'EnteteRegroupement':
			return {icone: 'fa fa-tag', libelle: 'Entête de regroupement'};
		case 'EnteteValeurGroupe':
			return {icone: 'fa fa-object-group', libelle: 'Valeur du groupe'};
		case 'EnteteAgregatGroupe':
			return {icone: 'fa fa-tag', libelle: 'Entête d\'agrégat de groupe'};
		case 'ValeurAgregatGroupe':
			return {icone: 'fa fa-plus', libelle: 'Valeur de l\'agrégat du groupe'};
		case 'EnteteAgregatTotal':
			return {icone: 'fa fa-tag', libelle: 'Entête d\'agrégat total'};
		case 'ValeurAgregatTotal':
			return {icone: 'fa fa-plus', libelle: 'Valeur de l\'agrégat total'};
		case 'FiltreTableau':
			return {icone: 'fa fa-filter', libelle: 'Filtre de tableau'};
		case 'AxePrincipal':
			return {icone: 'fa fa-tag', libelle: 'Libellé d\'axe'};
		case 'ValeurAxe':
			return {icone: 'fa fa-ruler-horizontal', libelle: 'Valeur de l\'axe'};
		case 'SerieGraphique':
			return {icone: 'fa fa-tag', libelle: 'Libellé de série'};
		case 'ValeurSerie':
			return {icone: 'fa fa-calculator', libelle: 'Valeur de série'};
	}
	return {icone: 'fa fa-question', libelle: `TODO : ${element.type}`};
}

export const ENCODAGES_FICHIER = [
    {chaine: 'windows-1252', libelle: 'Windows'},
    {chaine: 'UTF-8', libelle: 'UTF-8'}
];

export const DELIMITEURS_FICHIER = [
    {chaine: ';', libelle: 'Point-virgule (;)'},
    {chaine: ',', libelle: 'Virgule (,)'},
    {chaine: '\t', libelle: 'Tabulation (\t)'},
    {chaine: '|', libelle: 'Barre horizontale (|)'}
];

export const SEPARATEURS_DECIMAUX = [
    { chaine: '.', libelle: 'Point (.)' },
    { chaine: ',', libelle: 'Virgule (,)' }
];

export function decrireStatutJeuDonnees(statut) {
    switch(statut) {
        case 'INITIAL':
            return 'Initial';
        case 'A_CALCULER':
            return 'À recalculer';
        case 'A_JOUR':
            return 'À jour';
        case 'CALCUL_EN_COURS':
            return 'En cours de recalcul';
        default:
            return 'Inconnu';
    }
}
